<template>
  <section class="py-20">
    <div class="max-w-6xl mx-auto px-6">
      <div class="text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold mb-4" :class="isDark ? 'text-white' : 'text-gray-800'">
          <span :class="isDark ? 'text-gray-400' : 'text-gray-500'">// </span>最新动态
        </h2>
        <p :class="isDark ? 'text-gray-400' : 'text-gray-500'">记录开发点滴和技术思考</p>
        <div class="w-20 h-1 bg-green-500 mx-auto mt-4"></div>
      </div>

      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div 
          v-for="note in notes" 
          :key="note.id"
          class="rounded-lg p-4 border transition-all hover:shadow-lg cursor-pointer"
          :class="isDark ? 'bg-gray-800 border-gray-700 hover:border-green-500/50' : 'bg-gray-50 border-gray-200 hover:border-green-500/50'"
        >
          <div class="flex items-center justify-between mb-2">
            <span class="text-xs px-2 py-1 rounded-full"
                  :class="note.type === 'tech' ? (isDark ? 'bg-blue-500/20 text-blue-400' : 'bg-blue-100 text-blue-600') : 
                          note.type === 'life' ? (isDark ? 'bg-purple-500/20 text-purple-400' : 'bg-purple-100 text-purple-600') :
                          (isDark ? 'bg-green-500/20 text-green-400' : 'bg-green-100 text-green-600')">
              {{ note.typeLabel }}
            </span>
            <span class="text-xs" :class="isDark ? 'text-gray-500' : 'text-gray-400'">{{ note.date }}</span>
          </div>
          <p class="text-sm" :class="isDark ? 'text-gray-300' : 'text-gray-700'">{{ note.content }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useTheme } from '../composables/useTheme'

export default {
  name: 'Notes',
  setup() {
    const { isDark } = useTheme()
    return { isDark }
  },
  data() {
    return {
      notes: [
        { id: 1, content: '今天学习了 Vue 3 的 Teleport 组件，非常实用！', type: 'tech', typeLabel: '技术', date: '2小时前' },
        { id: 2, content: '完成了个人网站的改版设计', type: 'life', typeLabel: '生活', date: '5小时前' },
        { id: 3, content: '阅读了《Clean Code》第三章，收获很多', type: 'tech', typeLabel: '技术', date: '昨天' },
        { id: 4, content: '周末计划整理一下博客文章', type: 'life', typeLabel: '生活', date: '2天前' },
        { id: 5, content: '尝试了 Tailwind CSS 3 的新特性', type: 'tech', typeLabel: '技术', date: '3天前' },
        { id: 6, content: '参加了线上技术分享会', type: 'event', typeLabel: '活动', date: '1周前' },
        { id: 7, content: '优化了网站的加载速度', type: 'tech', typeLabel: '技术', date: '1周前' },
        { id: 8, content: '开始学习 Rust 编程语言', type: 'tech', typeLabel: '技术', date: '2周前' }
      ]
    }
  }
}
</script>
